module.exports = __webpack_public_path__ + "img/lock1.048273fc.png";